export const FORGET_PASSWORD_LINK_REQUEST = "FORGET_PASSWORD_LINK_REQUEST";
export const FORGET_PASSWORD_LINK_RECEIVE = "FORGET_PASSWORD_LINK_RECEIVE";
export const FORGET_PASSWORD_LINK_FAILURE = "FORGET_PASSWORD_LINK_FAILURE";
export const RESET_FORGET_PASSWORD_LINK = "RESET_FORGET_PASSWORD_LINK";
